export const formatFiltersParams = (values: any): any =>
  Object.keys(values).reduce(
    (acc, item) => ({
      ...acc,
      [item]: values[item] === 'all' ? '' : values[item]
    }),
    {}
  )

export const formatUserFiltersParams = (values: any) =>
  Object.keys(values).reduce((acc, item) => {
    if (item !== 'is_external')
      return {
        ...acc,
        [item]: values[item] === 'all' ? '' : values[item]
      }

    if (item === 'is_external' && values[item] === 'all') return acc

    return {
      ...acc,
      [item]: values[item] === 'external'
    }
  }, {})

export const getFiltersFromLocalStorage = <T extends object>(storageName: string, defaultValue: T) => {
  try {
    const item = localStorage.getItem(storageName)
    const localStorageValues = item ? JSON.parse(item) : {}

    return Object.keys(defaultValue).reduce(
      (acc, cur) =>
        localStorageValues[cur]
          ? {
            [cur]: localStorageValues[cur] === 'all' ? '' : localStorageValues[cur],
            ...acc
          }
          : acc,
      {}
    )
  } catch (error) {
    return defaultValue
  }
}

export const getFilter = <T extends object>(storageName: string, defaultValue: T) => {
  try {
    const item = localStorage.getItem(storageName)
    const localStorageValues = item ? JSON.parse(item) : {}

    return {
      ...defaultValue,
      // TODO: formatFiltersParams needs to be removed in time when we are sure that no 'all' in local storage
      ...formatFiltersParams(localStorageValues)
    }
  } catch (error) {
    return defaultValue
  }
}
